import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onDeliveryMethodsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onDeliveryMethodsDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="deliveryMethod"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onDeliveryMethodsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
